import { actionTypes } from 'redux-resource';

import * as api from '../api';
import { PER_PAGE } from 'helpers/actions';

export const fetchTracfoneSubLeases =
  (subId, page = 1, params) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'tracfoneLeases',
      requestKey: `fetchBySub${page}`,
      list: `subLeases${page}`,
      mergeListIds: false,
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.READ_RESOURCES_PENDING,
    });

    return api
      .fetchTracfoneSubLeases(subId, page, params)
      .then((response) => {
        const { count, next, previous, results } = response.data;
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_SUCCEEDED,
          resources: results || [],
          requestProperties: {
            perPage: (results && results.length) || PER_PAGE,
            count,
            next,
            previous,
          },
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.READ_RESOURCES_FAILED,
        });
      });
  };
